<template>
    <v-card>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
            <v-card-title>
                <h3 class="headline mb-0"><span style="color: #9C1A1A">Solicitud de Papel</span></h3>
            </v-card-title>
            <v-card-text>

                <!-- <v-flex xs12>
                    <v-flex xs12>
                        <p style="margin-left: 10px;">Tipo de Papel</p>
                        <v-radio-group style="margin-left: 10px;" v-model="form.tipo_hoja" row @change="verificarExistencia">
                            <v-radio color="primary" label="Hoja Física" value="FISICA"></v-radio>
                            <v-radio color="primary" label="Hoja Digital" value="DIGITAL"></v-radio>
                        </v-radio-group>
                    </v-flex>
                </v-flex> -->

                <v-flex xs12 v-if="form.tipo_hoja != ''">
                    <v-text-field
                        ref="cantidad"
                        @blur="verificarExistencia"
                        v-model="form.cantidad"
                        mask="####"
                        prepend-icon="library_books"
                        label="Cantidad a Solicitar"
                        :rules="[v => !!v || 'La cantidad es requerido']"
                        required
                    ></v-text-field>
                </v-flex>

                        <v-flex xs12 align-center justify-space-between v-if="form.tipo_hoja != ''">
                            <v-layout align-center>
                                <v-flex xs12 sm4>
                                    <v-text-field
                                        ref="rif"
                                        v-model="form.rif"
                                        prepend-icon="featured_video"
                                        label="RIF"
                                        :rules="[v => !!v || 'RIF es requerido']"
                                        required
                                        mask="A-########-#"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm8>
                                    <v-text-field
                                        ref="razonsocial"
                                        v-model="form.razon_social"
                                        prepend-icon="person"
                                        label="Razon social"
                                        :rules="[v => !!v || 'Razon social es requerido']"
                                        required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                         <v-flex xs12 v-if="form.tipo_hoja != ''">
                            <v-text-field
                                ref="direccionfiscal"
                                v-model="form.direccion_fiscal"
                                prepend-icon="domain"
                                label="Direccion Fiscal"
                                :rules="[v => !!v || 'Direccion Fiscal es requerido']"
                                required
                            ></v-text-field>
                        </v-flex>

                        <!-- <v-flex xs12 v-if="pagoActivo && form.tipo_hoja == 'FISICA'">
                            <p style="margin-left: 10px;">Delivery</p>
                            <v-radio-group style="margin-left: 10px;" v-model="delivery" row>
                                <v-radio color="primary" label="SI" :value="true"></v-radio>
                                <v-radio color="primary" label="NO" :value="false"></v-radio>
                            </v-radio-group>
                        </v-flex> -->

                        <v-flex xs12 v-if="pagoActivo && active_nc">
                            <p style="margin-left: 20px;">Usted posee un crédito por BsS: {{ new Intl.NumberFormat("de-DE").format(form.saldo_nc) }} desea usarlo? {{ form.uso_nc ? `quedan BsS ${new Intl.NumberFormat("de-DE").format(getResultNotaCredito)}` : '' }}</p>
                            <v-radio-group style="margin-left: 10px;" v-model="form.uso_nc" row>
                                <v-radio color="primary" label="SI" :value="true"></v-radio>
                                <v-radio color="primary" label="NO" :value="false"></v-radio>
                            </v-radio-group>
                        </v-flex>

                        <v-flex xs12 align-center justify-space-between v-if="pagoActivo">
                            <v-layout align-center>
                                <v-flex xs12 sm6 v-if="Number(getPricePaper) > 0">
                                    <v-select
                                        prepend-icon="account_balance_wallet"
                                        :items="wayToPay"
                                        v-model="form.way_to_pay"
                                        @change="changeWayToPay"
                                        label="Método de pago"
                                        :rules="[v => !!v || 'Método de pago es requerido']"
                                        required
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12 sm6>
                                    <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
                                        <div class="v-input__prepend-outer">
                                        <div class="v-input__icon v-input__icon--prepend">
                                            <i aria-hidden="true" class="v-icon material-icons theme--light">credit_card</i>
                                        </div>
                                        </div>
                                        <div class="v-input__control">
                                        <div class="v-input__slot">
                                            <div class="v-text-field__slot">
                                            <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Monto a pagar</label>
                                            <vue-numeric read-only currency="BsS" :value="Number(getPricePaper)" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                                            </div>
                                        </div>
                                        <div class="v-text-field__details">
                                            <div class="v-messages theme--light">
                                            <div class="v-messages__wrapper">
                                                Precio con IVA + SERVICIO incluido
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 v-if="pagoActivo && Number(getPricePaper) > 0">
                            <ul>
                                <li>Por favor proceda a realizar el pago en la siguiente cuenta bancaria:</li>
                                <li>BANESCO</li>
                                <li>A nombre del: Colegio de Contadores Públicos Distrito Capital</li>
                                <li>Rif: J-00066535-4 </li>
                                <li>Cuenta Corriente: 0134-0038-5103-8307-5688</li>
                            </ul>
                        </v-flex>

                        <v-flex xs12 v-if="pagoActivo && Number(getPricePaper) > 0">
                            <v-select
                                v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                prepend-icon="account_balance"
                                :items="banks"
                                v-model="form.bank_id"
                                item-text="name"
                                item-value="id"
                                label="Banco"
                                :rules="[v => !!v || 'Banco de pago es requerido']"
                                required
                            ></v-select>
                        </v-flex>

                        <v-flex xs12 align-center justify-space-between v-if="pagoActivo && Number(getPricePaper) > 0">
                            <v-layout align-center>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                        ref="number"
                                        v-model="form.number"
                                        prepend-icon="remove"
                                        label="Número de transacción"
                                        mask="###############"
                                        :rules="[v => !!v || 'Número de transacción es requerido']"
                                        required
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-menu
                                        ref="menu"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="menu"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        min-width="290px"
                                        :return-value.sync="date"
                                    >
                                        <v-text-field
                                            slot="activator"
                                            label="Fecha"
                                            v-model="computedDateFormattedFecha"
                                            hint="DD/MM/YYYY formato"
                                            prepend-icon="event"
                                            :rules="[v => !!v || 'Fecha es requerido']"
                                            required
                                            readonly
                                        ></v-text-field>
                                        <v-date-picker :max="new Date().toISOString().slice(0,10)" v-model="form.payment_date" no-title scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                        <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 v-if="pagoActivo && Number(getPricePaper) > 0">
                            <input hidden type="file" ref="fileInput" @change="processFile($event)">
                            <v-text-field
                                :rules="[v => !!v || 'Comprobante de pago es requerido']"
                                ref="document"
                                v-model="nameImg"
                                @click.native="onFocus"
                                prepend-icon="attach_file"
                                label="Comprobante de pago"
                            ></v-text-field>
                        </v-flex>

            </v-card-text>
            <v-card-actions>
                <v-btn :disabled="loading" color="primary darken-1" @click="closePay">Cerrar</v-btn>
                <v-spacer></v-spacer>
                <v-btn :disabled="!pagoActivo" :loading="loading" color="primary" @click="confirmData">Solicitar</v-btn>
            </v-card-actions>
        </v-form>

        <!-- <v-dialog v-model="dialogDelivery" width="600" persistent>
            <v-form ref="formdelivery" v-model="valid2" lazy-validation enctype="multipart/form-data">
                <v-card>
                    <v-card-title>
                        <h3 class="headline mb-0"><span style="color: #9C1A1A">Datos Delivery</span></h3>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 sm6>
                                    <v-select
                                        prepend-icon="edit_location"
                                        :items="estados"
                                        v-model="form.estado_id"
                                        @change="getMunicipios"
                                        item-text="name"
                                        item-value="id"
                                        label="Estado"
                                        :rules="[v => !!v || 'Estado es requerido']"
                                        required
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-select
                                        :disabled="municipios.length == 0"
                                        prepend-icon="edit_location"
                                        :items="municipios"
                                        v-model="form.municipio_id"
                                        @change="getParroquias"
                                        item-text="name"
                                        item-value="id"
                                        label="Municipio"
                                        :rules="[v => !!v || 'Municipio es requerido']"
                                        required
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-select
                                        :disabled="parroquias.length == 0"
                                        prepend-icon="edit_location"
                                        :items="parroquias"
                                        v-model="form.parroquia_id"
                                        @change="getSectores"
                                        item-text="name"
                                        item-value="id"
                                        label="Parroquia"
                                        :rules="[v => !!v || 'Parroquia es requerido']"
                                        required
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-select
                                        :disabled="sectores.length == 0"
                                        prepend-icon="edit_location"
                                        :items="sectores"
                                        v-model="form.sector_id"
                                        @change="getDeliveryAmount"
                                        item-text="name"
                                        item-value="id"
                                        label="Sector"
                                        :rules="[v => !!v || 'Sector es requerido']"
                                        required
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12>
                                <v-textarea
                                    ref="address"
                                    prepend-icon="domain"
                                    v-model="form.address"
                                    auto-grow
                                    box
                                    color="primary"
                                    label="Dirección"
                                    rows="1"
                                    :rules="[v => !!v || 'Dirección es requerido']"
                                    required
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    ref="guide_mark"
                                    prepend-icon="location_on"
                                    v-model="form.guide_mark"
                                    auto-grow
                                    box
                                    color="primary"
                                    label="Punto de Referencia"
                                    rows="1"
                                    :rules="[v => !!v || 'Punto de Referencia es requerido']"
                                    required
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                    ref="local_phone"
                                    v-model="form.local_phone"
                                    prepend-icon="phone"
                                    label="Tlf Local"
                                    mask="phone"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                    ref="celular_phone"
                                    v-model="form.celular_phone"
                                    prepend-icon="phone"
                                    label="Tlf Célular"
                                    :rules="[v => !!v || 'Tlf Célular es requerido']"
                                    required
                                    mask="phone"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    ref="responsable"
                                    v-model="form.responsable"
                                    prepend-icon="person"
                                    label="Responsable"
                                    :rules="[v => !!v || 'Responsable es requerido']"
                                    required
                                ></v-text-field>
                            </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary darken-1" @click="disactiveDelivery">Cerrar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="confirmDataDelivery">Aceptar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog> -->

    </v-card>
</template>
<script>
import Form from 'vform'
import axios from 'axios'
import VueNumeric from 'vue-numeric'

Number.prototype.toFixedDown = function(digits) {
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
};

export default {

    props: {
        banks: {
            type: Array,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    },

    components: {
        VueNumeric
    },

    watch: {
        delivery (v) {
            if (v) {
                 this.form.precioD = this.oldDeliveryPrice
            }else {
                this.disactiveDelivery()
            }
            this.dialogDelivery = v
        }
    },

    data: () => ({
        oldTipoHoja: 'FISICA',
        oldCantidad: 0,
        oldDeliveryPrice: 0,
        date: null,
        fecha: null,
        active_nc: false,
        pagoActivo: false,
        menu: false,
        precio: 0,
        precio_se: 0,
        tax: 0,
        delivery: false,
        valid: false,
        valid2: false,
        dialogDelivery: false,
        wayToPay: ['TRANSFERENCIA'],
        estados: [],
        municipios: [],
        parroquias: [],
        sectores: [],
        nameImg: '',
        form: new Form({
            tipo_hoja: 'FISICA',
            estado_id: '',
            municipio_id: '',
            parroquia_id: '',
            sector_id: '',
            precioD: 0,
            saldo_nc: 0,
            cantidad: '',
            way_to_pay: 'TRANSFERENCIA',
            number: null,
            payment_date: '',
            observations: '',
            rif: '',
            file: '',
            document: '',
            razon_social: '',
            direccion_fiscal: '',
            address: '',
            local_phone: '',
            celular_phone: '',
            responsable: '',
            guide_mark: '',
            agreement: false,
            uso_nc: false,
            delivery: false
        })
    }),

    computed: {

        getResultNotaCredito () {
            let saldo_nc = parseFloat(this.form.saldo_nc)
            let monto_cantidad = parseFloat(this.form.cantidad) * parseFloat(this.precio)
            let monto_add_se = monto_cantidad + parseFloat(this.precio_se)
            let monto_total = parseFloat(monto_add_se + this.form.precioD).toFixedDown(2)
            let monto_total_result = 0

            monto_total_result = parseFloat(saldo_nc - monto_total).toFixedDown(2)

            if (this.form.uso_nc) {
                if(monto_total_result < 0){
                    monto_total = 0
                }else {
                    monto_total = monto_total_result
                }
            }else {
                monto_total = saldo_nc
            }

            return monto_total
        },

        getPricePaper () {
            let monto_cantidad = parseFloat(this.form.cantidad) * parseFloat(this.precio)
            let monto_add_se = monto_cantidad + parseFloat(this.precio_se)
            let monto_total = parseFloat(monto_add_se + this.form.precioD).toFixedDown(2)
            let monto_total_result = 0

            if (this.form.uso_nc) {
                monto_total_result = parseFloat(monto_total - this.form.saldo_nc).toFixedDown(2)
                if(monto_total_result < 0){
                    monto_total = 0
                }else {
                    monto_total = monto_total_result
                }
            }

            return monto_total
        },

        computedDateFormattedFecha () {
            return this.formatDate(this.form.payment_date)
        },

    },

    mounted () {
        this.$store.dispatch('clearMessage')
        this.getEstados()
    },

    methods: {

        async verificarExistencia() {
            if(this.oldCantidad != this.form.cantidad || this.oldTipoHoja != this.form.tipo_hoja){
                this.$emit('loadingResponse', true)
                await axios.get(`/api/cliente/security-paper-available/${this.form.cantidad}/${this.form.tipo_hoja}`)
                    .then(() => {
                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            text: 'La cantidad de papeles ingresada esta disponible!..'
                        })
                        this.pagoActivo = true
                        this.getMountPaper()
                    })
                    .catch(e => {
                        this.pagoActivo = false
                        console.log(e.response)
                            if (e.response.data.errors) {
                                if (e.response.data.errors.no_available) {
                                    this.$store.dispatch('responseMessage', {
                                        type: 'error',
                                        text: e.response.data.errors.no_available
                                    })
                                }else {
                                    this.$store.dispatch('responseMessage', {
                                        type: 'error',
                                        text: e.response.data.error
                                    })
                                }
                            }
                    })
                    .finally(() => this.$emit('loadingResponse', false));
            }
            this.oldCantidad = this.form.cantidad
            this.oldTipoHoja = this.form.tipo_hoja
            if (this.form.tipo_hoja == 'DIGITAL') {
                this.delivery = false
                this.form.delivery = false
            }
        },

        disactiveDelivery() {
            this.form.guide_mark = ''
            this.form.estado_id = ''
            this.form.municipio_id = ''
            this.form.parroquia_id = ''
            this.form.sector_id = ''
            this.form.precioD = 0
            this.delivery = false
            this.form.delivery = false
            this.form.address = ''
            this.form.local_phone = ''
            this.form.celular_phone = ''
            this.form.responsable = ''
            this.dialogDelivery = false
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        async changeWayToPay() {
            if(this.form.way_to_pay == 'EFECTIVO - MONEDA LOCAL'){
                this.form.number = null
            }
            if(this.form.way_to_pay == 'EFECTIVO - DIVISAS'){
                this.form.number = null
            }
        },

        onFocus() {
            this.$refs.fileInput.value = ''
            this.$refs.fileInput.click()
        },

        processFile(event) {
            let files = event.target.files || event.dataTransfer.files
            if (files[0].type == "image/png" || files[0].type == "image/jpg" || files[0].type == "image/jpeg" || files[0].type == "application/pdf") {
                this.form.file = files[0]
                this.nameImg = files[0].name
            }else {
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'El formato del documento debe ser PNG/JPG/JPEG o PDF'
                })
            }
        },

        async closePay() {
            this.form = {
                saldo_nc: 0,
                precioD: 0,
                cantidad: '',
                way_to_pay: 'TRANSFERENCIA',
                number: null,
                tipo_hoja: 'FISICA',
                payment_date: '',
                observations: '',
                rif: '',
                razon_social: '',
                direccion_fiscal: '',
                uso_nc: false,
                agreement: false
            }
            this.$emit('closepapeldialog', false)
            this.$emit('loadingResponse', false)
        },

        async getMountPaper () {
            this.$emit('loadingResponse', true)
            await axios.get(`/api/cliente/security-paper-mount/${this.form.tipo_hoja}`)
                .then(res => {
                    this.active_nc = res.data.active_nc
                    this.form.saldo_nc = parseFloat(res.data.saldo_nc)
                    this.precio = parseFloat(res.data.monto_papeles)
                    this.precio_se = parseFloat(res.data.monto_servicio_electronico)
                    this.tax = res.data.iva == null ? 0 : parseFloat(res.data.iva)
                    this.form.razon_social = this.user.name
                    this.form.rif = this.user.rif
                })
                .catch(error => {
                    console.log(error.response)
                })
                .finally(() => this.$emit('loadingResponse', false));
        },

        async getEstados () {
            this.$emit('loadingResponse', true)
            await axios.get(`/api/cliente/get-estados`)
                .then(res => {
                    this.estados = res.data
                })
                .catch(error => {
                    console.log(error.response)
                })
                .finally(() => this.$emit('loadingResponse', false));
        },

        async getMunicipios () {
            this.$emit('loadingResponse', true)
            await axios.get(`/api/cliente/get-municipios/${this.form.estado_id}`)
                .then(res => {
                    this.municipios = res.data
                })
                .catch(error => {
                    console.log(error.response)
                })
                .finally(() => this.$emit('loadingResponse', false));
        },

        async getParroquias () {
            this.$emit('loadingResponse', true)
            await axios.get(`/api/cliente/get-parroquias/${this.form.municipio_id}`)
                .then(res => {
                    this.parroquias = res.data
                })
                .catch(error => {
                    console.log(error.response)
                })
                .finally(() => this.$emit('loadingResponse', false));
        },

        async getSectores () {
            this.$emit('loadingResponse', true)
            await axios.get(`/api/cliente/get-sectores/${this.form.parroquia_id}`)
                .then(res => {
                    if(res.data.length == 0){
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: 'No esta disponible esta parroquia'
                        })  
                    }else {
                        this.sectores = res.data
                    }
                })
                .catch(error => {
                    console.log(error.response)
                })
                .finally(() => this.$emit('loadingResponse', false));
        },

        async getDeliveryAmount () {
            this.$emit('loadingResponse', true)
            await axios.get(`/api/cliente/get-delivery-amount/${this.form.sector_id}`)
                .then(res => {
                    this.form.precioD = res.data
                    this.oldDeliveryPrice = res.data
                })
                .catch(e => {
                    console.log(e.response)
                    if (e.response.data.errors) {
                        if (e.response.data.errors.no_mount) {
                            this.$store.dispatch('responseMessage', {
                                type: 'error',
                                text: e.response.data.errors.no_mount
                            })
                        }else {
                            this.$store.dispatch('responseMessage', {
                                type: 'error',
                                text: e.response.data.error
                            })
                        }
                    }
                })
                .finally(() => this.$emit('loadingResponse', false));
        },

        async confirmData () {
            if (this.$refs.form.validate()) {
                this.$emit('loadingResponse', true)
                let formData = new FormData();
                for (var key in this.form) {
                    formData.append(key, this.form[key]);
                }
                await axios.post(`/api/cliente/security-paper-solicitud`,formData)
                    .then(res => {
                        this.$emit('responseForm')
                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            text: 'Solicitud Exitosa!..'
                        })
                        this.$store.dispatch('fetchSaldo')
                        this.closePay()
                    })
                    .catch(e => {
                        console.log(e.response)
                        if (e.response.data.errors) {
                            if (e.response.data.errors.security_paper) {
                                this.$store.dispatch('responseMessage', {
                                    type: 'error',
                                    text: e.response.data.errors.security_paper
                                })
                            }else {
                                this.$store.dispatch('responseMessage', {
                                    type: 'error',
                                    text: e.response.data.error
                                })
                            }
                        }
                    })
                    .finally(() => this.$emit('loadingResponse', false));
            }
        },

        async confirmDataDelivery () {
            if (this.$refs.formdelivery.validate()) {
                this.form.delivery = true
                this.dialogDelivery = false
            }
        },

    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cliente/FormSolicitudPapel.vue